<template>
  <div>
    <TopHeader code="know" />

    <section class="container-fluid uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link to="" class="item">案例库</router-link>
              <router-link to="" class="item">
                {{ this.treeSelName }}
              </router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24 col-sm-6">
            <div class="g-sideMenu">
              <div class="title" @click="handleTreeRoot">全部资源</div>
              <div class="list">
                <el-tree
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :expand-on-click-node="false"
                  :data="treeData.children"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                ></el-tree>
              </div>
            </div>
          </div>

          <div class="col-24 col-sm-18">
            <section
              class="uc-knowledgeFilter uc-ml10"
              v-if="tagList.length > 0"
            >
              <div class="item" v-for="(item, index) in tagList" :key="index">
                <span class="txt">{{ item.name }}</span>
                <div class="con">
                  <a
                    href="javascript:;"
                    :class="tagSel == 0 ? 'on' : ''"
                    @click="
                      tagSel = 0;
                      handleTagClick(undefined);
                    "
                    >全部</a
                  >
                  <a
                    href="javascript:;"
                    v-for="(item, index) in item.tag_list"
                    :key="index"
                    :class="tagSel == item.id ? 'on' : ''"
                    @click="
                      tagSel = item.id;
                      handleTagClick(item.id);
                    "
                    >{{ item.label }}</a
                  >
                </div>
              </div>
            </section>

            <section class="g-filterSearch uc-ml10">
              <div
                v-for="(item, index) in tabList"
                :key="index"
                class="item"
                :class="item.orderby == query.orderby ? 'on' : ''"
                @click="
                  query.orderby = item.orderby;
                  loadData();
                "
              >
                {{ item.name }}
              </div>
              <div class="search">
                <input
                  type="text"
                  placeholder="请输入您想搜索的资源"
                  class="uc-input"
                  v-model="query.keyword"
                  @keyup.enter="loadData"
                />
                <input
                  type="submit"
                  value="搜索"
                  class="uc-btn blue"
                  @click="loadData"
                />
              </div>
            </section>

            <section class="g-list style-radius uc-ml10">
              <div class="content-empty" v-if="list.total_count == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div
                v-for="(item, index) in list.items"
                :key="index"
                class="item"
              >
                <router-link
                  :to="{
                    name: 'KnowledgeDetails',
                    params: { id: item.id },
                  }"
                  class="con"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-zs.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">{{ item.create_time }}</div>
                  </div>
                </router-link>
              </div>
            </section>

            <el-pagination
              class="uc-prvNxt"
              background
              layout="prev, pager, next"
              hide-on-single-page
              :current-page="query.pageIndex"
              :page-size="query.pageSize"
              :total="list.total_count"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="uc-FixedSideMenu" v-show="false">
      <div class="box">
        <a href="javascript:;;" class="btn-share">
          <img
            src="../../assets/images/icon-share.png"
            alt="我要分享"
            class="uc-icon24"
          />
          我要分享
        </a>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'Knowledge',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      tagSel: 0,
      tabList: [
        {
          name: '最新',
          orderby: 0,
        },
        {
          name: '最热',
          orderby: 1,
        },
      ],
      query: {
        catalogId: undefined,
        tagId: undefined,
        pageIndex: 1,
        pageSize: 9,
        orderby: this.$route.query.orderby || 0,
        keyword: undefined,
      },
      list: [],
      tagList: [],
      treeData: {},
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      treeSelName: '全部',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getTags();
      this.getKnowledges();
      this.getCatalogTree();
    },
    loadData() {
      this.getKnowledges();
    },
    async getTags() {
      const response = await this.$api.tag.getTags();
      this.tagList = response.data.data;
    },
    async getKnowledges() {
      const response = await this.$api.knowledge.getKnowledges(this.query);
      this.list = response.data.data;
    },
    async getCatalogTree() {
      const response = await this.$api.knowledge.getCatalogTree();
      this.treeData = response.data.data;
    },
    btnShowFixedMenu() {
      this.showFixedMenu = !this.showFixedMenu;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    // 切换标签
    handleTagClick(tagId) {
      this.query.tagId = tagId;
      this.loadData();
    },
    // 切换目录
    handleNodeClick(item) {
      this.query.catalogId = item.id;
      this.treeSelName = item.name;
      this.loadData();
    },
    // 根目录
    handleTreeRoot() {
      this.query.catalogId = undefined;
      this.$refs.tree.setCurrentKey(null);
      this.treeSelName = '全部';
      this.loadData();
    },
  },
};
</script>
